import { getObjKeySort } from './utils.js';
import { PRIVATEKEY } from './config.js';

const md5 = require('js-md5');
/*
 ** 签名封装
 ** @params data 请求数据
 ** @params webToken  登录token
 ** @params timestamp  时间戳, 可不传,不传则获取新的时间戳
 */
export function signData(data, webToken, timestamp) {
  let signStr = '';
  // key值按照字母排序的对象字符串
  const datastr = getObjKeySort(data).sortObjStr;

  if (!timestamp) timestamp = new Date().getTime();
  if (webToken) {
    signStr = `webToken:${webToken}|time:${timestamp}|privateKey:${PRIVATEKEY}|data:${datastr}`;
  } else {
    signStr = `time:${timestamp}|privateKey:${PRIVATEKEY}|data:${datastr}`;
  }
  const sign = md5(signStr);

  let result = {
    time: timestamp,
    sign,
    data: data
  };
  webToken && (result.webToken = webToken);
  return result;
}
